<template>
  <div>
    <!-- 选择令牌 -->
    <jd-dialog
      top="5vh"
      title="选择令牌"
      :visible.sync="value"
      append-to-body
      width="1200px"
      @close="handlerClose"
    >
      <jd-tip style="margin: 0 0 10px 0">
        提示：商家需手工添加官方申请的令牌，以下填写的信息请务必与官方申请的信息一致，否则会导致活动异常，引起客诉
      </jd-tip>
      <jd-form
        ref="jdForm"
        :form-info="formInfo"
        @search="searchGiftCardDetail"
      />
      <!-- <input-form
        ref="inputRef"
        :inputData="inputDataDetail"
        :btnPosition1="true"
        @toParentVal="searchGiftCardDetail"
      ></input-form> -->
      <jd-table
        class="token-table"
        ref="checkTable"
        :tableData="giftCardList"
        :loading="tableDetailLoading"
        :tableInfo="tableInfo"
        :pageInfo="{
          pageSize: formList.size,
          pageNum: formList.current,
          total: totalDetail,
        }"
        style="margin-top: 12px"
        @handlePage="handlePage"
        @select="handleSelectionChange"
        :selection="true"
        rowKey="id"
        :selectable="selectable"
      >
        <template #tokenInfo="scope">
          <div>令牌名称：{{ scope.row.name }}</div>
          <div>令牌ID：{{ scope.row.tokenId }}</div>
          <div>令牌密钥：{{ scope.row.secretKey }}</div>
        </template>
        <template #createTime="scope">
          <div>{{ scope.row.createTime }}</div>
        </template>
        <template #startTime="scope">
          <span>起：{{ scope.row.startTime }}</span
          ><br />
          <span>止：{{ scope.row.endTime }}</span>
        </template>
        <template #status="scope">
          <div>
            {{
              scope.row.status == 1
                ? "待生效"
                : scope.row.status == 2
                ? "已生效"
                : scope.row.status == 3
                ? "已结束"
                : ""
            }}
          </div>
        </template>
        <template #promoType="{ row }">
          <div v-if="row.promoType == 0">赠品促销</div>
          <div v-else-if="row.promoType == 1">单品促销</div>
          <div v-else-if="row.promoType == 2">套装促销</div>
          <div v-else-if="row.promoType == 3">总价促销</div>
          <div v-else>赠品促销</div>
        </template>
      </jd-table>
      <!-- <el-table
        class="token-table"
        ref="checkTable"
        row-key="id"
        v-loading="tableDetailLoading"
        :data="giftCardList"
        style="width: 100%"
        height="400"
        @select="handleSelectionChange"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column type="selection" reserve-selection></el-table-column>
        <el-table-column label="令牌信息">
          <template slot-scope="scope">
            <div>令牌名称：{{ scope.row.name }}</div>
            <div>令牌ID：{{ scope.row.tokenId }}</div>
            <div>令牌密钥：{{ scope.row.secretKey }}</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            <div>{{ scope.row.createTime }}</div>
          </template>
        </el-table-column>
        <el-table-column label="令牌描述">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="light"
              :content="scope.row.description"
              placement="bottom"
            >
              <div class="remark-tip">
                {{ scope.row.description }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="令牌有效时间">
          <template slot-scope="scope">
            <span>起：{{ scope.row.startTime }}</span
            ><br />
            <span>止：{{ scope.row.endTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时效状态">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.status == 1
                  ? "待生效"
                  : scope.row.status == 2
                  ? "已生效"
                  : scope.row.status == 3
                  ? "已结束"
                  : ""
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="促销活动类型" width="180">
          <template #default="{ row }">
            <div v-if="row.promoType == 0">赠品促销</div>
            <div v-else-if="row.promoType == 1">单品促销</div>
            <div v-else-if="row.promoType == 2">套装促销</div>
            <div v-else-if="row.promoType == 3">总价促销</div>
            <div v-else>赠品促销</div>
          </template>
        </el-table-column>
      </el-table> -->
      <!-- <div class="new-pagination-page" style="margin-top: 20px">
        <el-pagination
          background
          @size-change="handleDetailSizeChange"
          @current-change="handleDetailCurrentChange"
          :current-page="formList.current"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          style="text-align: right; margin-top: 10px"
          :total="totalDetail"
        ></el-pagination>
      </div> -->
      <div slot="footer" class="dialog-footer">
        <jd-button @click="tokenSure" type="blue">确 定</jd-button>
        <jd-button @click="$emit('input', false)">取 消</jd-button>
      </div>
    </jd-dialog>
  </div>
</template>
<script>
import {
  promoTokenPage, //令牌分页
  promoTokenDetail, //令牌详情接口
} from "@/api/integralCenter/tokenSummary.js";
export default {
  name: "selectTokenDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tokenId: {
      type: String,
      default: "",
    },
    isSetDisabled: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    tokenId: {
      handler: function (val) {
        if (val) {
          this.ids = val;
        }
        this.getGiftCardDetail();
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  components: {},
  data() {
    return {
      focus: [
        {
          timesOne: "",
          timesTwo: "",
          promotiProducts: [], //促销商品列表
          promotiProductsOne: [], //赠品SKU
        },
      ],
      promoti: [],
      totalDetail: 0,
      tableDetailLoading: false,
      formList: {
        current: 1,
        size: 10,
        tokenId: "",
        name: "",
        createStartTime: "",
        createEndTime: "",
        tokenStartTime: "",
        tokenEndTime: "",
        status: "",
      },
      giftCardList: [],
      tableInfo: [
        {
          label: "令牌信息",
          prop: "tokenInfo",
          slot: "tokenInfo",
        },
        {
          label: "创建时间",
          prop: "createTime",
        },
        {
          label: "令牌描述",
          prop: "description",
          showOverflowTooltip: true,
        },
        {
          label: "令牌有效时间",
          prop: "startTime",
          slot: "startTime",
        },
        {
          label: "时效状态",
          prop: "status",
          slot: "status",
        },
        {
          label: "促销活动类型",
          prop: "promoType",
          slot: "promoType",
          width: "180",
        },
      ],
      formInfo: [
        {
          label: "令牌名称：",
          prop: "name",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "令牌ID：",
          prop: "tokenId",
          type: "Input",
          isNumber: true,
          placeholder: "请输入",
        },
        {
          label: "令牌有效时间：",
          prop: "dateRange1",
          type: "DateRange",
          dateType: "datetime",
          startKey: "tokenStartTime",
          endKey: "tokenEndTime",
          defalutLimit: true,
        },
        {
          label: "创建时间：",
          prop: "dateRange2",
          type: "DateRange",
          dateType: "datetime",
          startKey: "createStartTime",
          endKey: "createEndTime",
          defalutLimit: true,
        },
        {
          label: "时效状态：",
          prop: "status",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "待生效", value: 1 },
            { label: "已生效", value: 2 },
            { label: "已结束", value: 3 },
          ],
        },
      ],
      inputDataDetail: [
        {
          name: "令牌名称",
          val: "name",
          placeholder: "请输入",
        },
        {
          name: "令牌ID",
          val: "tokenId",
          placeholder: "请输入",
        },
        {
          name: "令牌有效时间",
          myDate: true,
          val: ["tokenStartTime", "tokenEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
        {
          name: "创建时间",
          myDate: true,
          val: ["createStartTime", "createEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
        {
          name: "时效状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "待生效", id: 1 },
            { label: "已生效", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
      ],
      selectTokenDialog: false, //令牌
    };
  },
  computed: {},
  methods: {
    selectable(row) {
      // 外传状态是否已结束的禁用
      if(!this.isSetDisabled) {
        return true
      } else {
        return row.status != 3;
      }
    },
    //选择令牌
    handleSelectionChange(selection, val) {
      this.$refs.checkTable.handleClearSelection();
      // this.$refs.checkTable.clearSelection();
      this.$refs.checkTable.toggleRowSelection(val, true);
      this.promoti = [val];
      this.ids = this.promoti[0] && this.promoti[0].id;
    },
    //分页变化事件
    handlePage(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getGiftCardDetail();
    },
    handleDetailSizeChange(val) {
      this.formList.size = val;
      this.getGiftCardDetail();
    },
    handleDetailCurrentChange(val) {
      this.formList.current = val;
      this.getGiftCardDetail();
    },
    searchGiftCardDetail(val) {
      console.log(val);
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.name = val.name;
      this.formList.createStartTime =
        val.createStartTime == null ? "" : val.createStartTime;
      this.formList.createEndTime =
        val.createEndTime == null ? "" : val.createEndTime;
      this.formList.tokenStartTime =
        val.tokenStartTime == null ? "" : val.tokenStartTime;
      this.formList.tokenEndTime =
        val.tokenEndTime == null ? "" : val.tokenEndTime;
      this.formList.tokenId = val.tokenId;
      this.formList.status = val.status;
      this.getGiftCardDetail();
    },
    //选择令牌明细
    async getGiftCardDetail() {
      this.tableDetailLoading = true;
      try {
        const res = await promoTokenPage(this.formList);
        if (res.code == 1) {
          this.tableDetailLoading = false;
          this.giftCardList = res.data.records;
          this.totalDetail = Number(res.data.total);
          const row = this.giftCardList.find((v) => v.id == this.ids);
          if (row) {
            this.$nextTick(() => {
              this.$refs.checkTable.toggleRowSelection(row, true);
            });
          }
        } else {
          this.tableDetailLoading = false;
        }
      } catch (error) {
        this.tableDetailLoading = false;
      }
    },
    //选择令牌
    selectToken(val) {
      this.selectTokenDialog = true;
      this.formList.current = 1;
      this.formList.size = 10;
      this.$nextTick(() => {
        this.$refs.inputRef.formSearch();
      });
    },
    //选择令牌
    tokenSure() {
      const ids = (this.promoti[0] && this.promoti[0].id) || this.ids;
      if (!ids) {
        return this.$message.error("请先选择令牌");
      }
      let idsData = {
        id: ids,
      };
      // this.ids = idsData;
      this.focus = [];
      promoTokenDetail(idsData).then((res) => {
        const { detailList } = res.data;
        if (res.code == 1) {
          detailList.forEach((item, index) => {
            const {
              promoSkuList,
              giveSkuList,
              promoStartTime,
              promoEndTime,
              shadowSkuList,
            } = item;
            this.focus.push({
              timesOne: "",
              timesTwo: "",
              promotiProducts: [], //促销商品列表
              promotiProductsOne: [], //赠品SKU
            });
            this.focus[index].promotiProducts = promoSkuList;
            this.focus[index].promotiProductsOne = giveSkuList;
            this.focus[index].timesOne = promoStartTime;
            this.focus[index].timesTwo = promoEndTime;
          });
          this.$emit("confirm", { ...res.data, id: this.ids });
          // this.handlerClose();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handlerClose() {
      this.$emit("input", false);
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .token-table .el-table__header-wrapper th .cell .el-checkbox {
  display: none;
}
</style>
